/**
 * @desc: 短链接初始化来源
 *
 * 从 URL 中的 filter_short_id 查询参数获取短链接数据，
 * 解析出筛选器值。
 * priority: 20
 */
import { isEmpty } from '@intelligence/v3/utils/common';
import { normalizeFilterValueByItem } from '@intelligence/v3/filterControls/apiParams';
import { analysisFilterShortId } from '@intelligence/v3/utils/filter';

import type { IFilterItemConfig, IFilterValues } from '@intelligence/v3/filterCore/types';
import type { IFilterInitContext, IFilterInitSource } from '../types';

/** 判断短链恢复值是否显式包含当前页面字段 */
const hasOwnField = (target: IRecord, field: string): boolean => {
  return Object.prototype.hasOwnProperty.call(target, field);
};

export const shortLinkSource: IFilterInitSource = {
  name: 'shortLink',
  priority: 20,
  /** 读取 filter_short_id 对应的 filter，并只恢复当前页面 items 中存在的字段 */
  resolve: async (items: IFilterItemConfig[], _context: IFilterInitContext): Promise<IFilterValues> => {
    try {
      const shortIdData = await analysisFilterShortId();
      const filter = shortIdData?.filter;

      if (isEmpty(filter) || typeof filter !== 'object') {
        return {};
      }

      // 仅保留当前页面 items 配置中存在的 field
      const result: IFilterValues = {};

      items?.forEach((item) => {
        const itemField = item?.field || '';

        if (!itemField || !hasOwnField(filter, itemField)) {
          return;
        }

        const itemValue = filter?.[itemField];
        if (itemValue === undefined || itemValue === null) {
          return;
        }

        const normalizedValue = normalizeFilterValueByItem(item, itemValue);
        if (normalizedValue !== undefined && normalizedValue !== null) {
          result[itemField] = normalizedValue as IFilterValues[string];
        }
      });

      return result;
    } catch (error) {
      console.debug('[useFilterablePage/shortLink] 解析短链接失败', error);
      return {};
    }
  },
};
